export default "__VITE_ASSET__BxCreSfL__"